// extracted by mini-css-extract-plugin
export default {"container":"AIPromptInput__container___eYrxs","innerContainer":"AIPromptInput__innerContainer___xVH9V"};